// 3rd Party
import React, { Component } from 'react'
import * as THREE from 'three'
import OrbitContructor from 'three-orbit-controls'
import deepAssign from 'deep-assign'
import EventEmitter from 'eventemitter3'
import mixin from 'mixin'

// Post
import { ShaderPass, EffectComposer, RenderPass, UnrealBloomPass } from './libs/post/EffectComposer'

import FilmShader from './libs/post/Film'

import Logo from './assets/logo.png'

// Libs
import Config from './Config'
import FDG from './libs/FDG'

// CSS
import './App.css'

class App extends mixin(EventEmitter, Component) {
  constructor (props) {
    super(props)

    this.config = deepAssign(Config, this.props.config)

    this.running = true // whether the app is running

    this.currentFrame = 0 // current frame of animation
    this.prevAPICallFrame = 0 // last frame which API was called on

    this.FDG = null // Force Directed Graph class

    this.userInteracting = true // whether user is interacting with graph

    this.mousePos = new THREE.Vector2() // keep track of mouse position

    this.nodes = {} // node data
    this.edges = [] // edge data
    this.loadPrevCommit = false // load in the previous commit
    this.loadNextCommit = false // load in the next commit

    this.state = {
      play: this.config.FDG.autoPlay,
      spherize: this.config.FDG.sphereProject
    }
  }

  // customGEO () {
  //   if (this.FDG) {
  //     this.nodes = [
  //       {'t': 'f', 'p': '0'},
  //       {'t': 'f', 'p': '1'},
  //       {'t': 'f', 'p': '2'},
  //       {'t': 'f', 'p': '3'},

  //       {'t': 'f', 'p': '4'},
  //       {'t': 'f', 'p': '5'},
  //       {'t': 'f', 'p': '6'},

  //       {'t': 'f', 'p': '7'},
  //       {'t': 'f', 'p': '8'},

  //       {'t': 'f', 'p': '9'}
  //     ]
  //     this.edges = [
  //       0, 1, 0, 2, 0, 3,
  //       1, 2, 1, 3,
  //       2, 3,

  //       0, 4, 0, 5, 0, 6,
  //       4, 5, 4, 6,
  //       5, 6,

  //       4, 1,

  //       7, 4,
  //       7, 1,

  //       1, 8,
  //       4, 8,
  //       7, 8,

  //       6, 2,
  //       6, 8,
  //       8, 2,

  //       9, 6,
  //       9, 2,
  //       9, 8

  //     ]

  //     if (this.FDG.firstRun) {
  //       this.FDG.init({
  //         nodeData: this.nodes,
  //         edgeData: this.edges,
  //         nodeCount: this.config.FDG.nodeCount
  //       })
  //       this.FDG.setFirstRun(false)
  //     } else {
  //       this.FDG.refresh()
  //       this.FDG.init({
  //         nodeData: this.nodes,
  //         edgeData: this.edges,
  //         nodeCount: this.config.FDG.nodeCount
  //       })
  //     }
  //   }
  // }

  customGEO () {
    if (this.FDG) {
      this.nodes = []
      for (let index = 1; index <= 1000; index++) {
        this.nodes.push({'t': 'f', 'p': index.toString()})
      }

      this.edges = [
        1, 1001,
        1, 999,
        1, 998,
        1, 997,
        2, 1000,
        2, 999,
        2, 998,
        2, 998,
        3, 998,
        3, 997,
        3, 996,
        4, 1000,
        4, 999,
        4, 998,
        4, 996,
        5, 1000,
        5, 999,
        5, 998,
        6, 1000,
        6, 999,
        6, 998
      ]

      // this.edges = []
      for (let index = 1; index <= (this.nodes.length) - 12; index++) {
        for (let index2 = 0; index2 < 8; index2++) {
          let edge = Math.floor(Math.random() * 12 + index)
          this.edges.push(edge)
        }
      }

      if (this.FDG.firstRun) {
        this.FDG.init({
          nodeData: this.nodes,
          edgeData: this.edges,
          nodeCount: this.config.FDG.nodeCount
        })
        this.FDG.setFirstRun(false)
      } else {
        this.FDG.refresh()
        this.FDG.init({
          nodeData: this.nodes,
          edgeData: this.edges,
          nodeCount: this.config.FDG.nodeCount
        })
      }
    }
  }

  componentDidMount () {
    this.initStage()
  }

  initStage () {
    this.initScene()
    this.initCamera()
    this.initRenderer()
    this.initPost()
    this.initControls()
    this.initFDG()
    this.addEvents()

    this.customGEO()
    this.emit('ready')

    this.animate()
  }

  initPost () {
    this.composer = new EffectComposer(this.renderer)
    this.renderPass = new RenderPass(this.scene, this.camera)
    this.composer.addPass(this.renderPass)

    //    this.renderPass.renderToScreen = true
    this.setPostSettings()
  }

  setPostSettings () {
    // res, strength, radius, threshold
    this.bloomPass = new UnrealBloomPass(new THREE.Vector2(window.innerWidth, window.innerHeight), 0.4, 0.5, 0.1)
    // this.bloomPass.renderToScreen = true
    this.composer.addPass(this.bloomPass)

    this.FilmShaderPass = new ShaderPass(FilmShader)
    this.FilmShaderPass.renderToScreen = true
    this.composer.addPass(this.FilmShaderPass)

    // if (this.config.post.vignette) {
    //   if (this.vignettePass) {
    //     this.vignettePass.enabled = true
    //     this.renderPass.renderToScreen = false
    //   } else {
    //     this.vignettePass = new ShaderPass(Vignette)
    //     this.vignettePass.material.uniforms.bgColor.value = new THREE.Color(this.config.scene.bgColor)
    //     this.vignettePass.renderToScreen = true
    //     this.composer.addPass(this.vignettePass)
    //   }
    // } else {
    //   if (this.vignettePass) {
    //     this.vignettePass.enabled = false
    //   }
    // this.renderPass.renderToScreen = true
    // }
  }

  initControls () {
    this.OrbitControls = OrbitContructor(THREE)
    this.controls = new this.OrbitControls(this.camera, this.renderer.domElement)
    this.setControlsSettings()
  }

  setControlsSettings () {
    this.controls.minDistance = 200
    this.controls.maxDistance = 10000
    this.controls.enablePan = false
    this.controls.enableZoom = this.config.camera.enableZoom
    this.controls.zoomSpeed = 0.7
    this.controls.rotateSpeed = 0.07
    this.controls.enableDamping = true
    this.controls.dampingFactor = 0.04
  }

  initFDG () {
    this.FDG = new FDG(
      this.renderer,
      this.scene,
      this.config,
      this.camera,
      this.mousePos,
      this
    )
  }

  animate () {
    window.requestAnimationFrame(this.animate.bind(this))
    this.renderFrame()
  }

  renderFrame () {
    if (!this.running) {
      window.cancelAnimationFrame(this.animate)
      return
    }

    // this.FilmShaderPass.uniforms.time.value = window.performance.now() * 0.0000001

    this.currentFrame++

    if (this.FDG) {
      this.FDG.update()
    }

    if (this.config.scene.autoRotate) {
      this.scene.rotation.y += this.config.scene.autoRotateSpeed
    }

    // this.cameraFollowTarget()

    this.controls.update()

    if (this.FDG && this.config.dev.debugPicker) {
      this.renderer.render(this.FDG.pickingScene, this.camera)
    } else {
      // this.renderer.render(this.scene, this.camera)
      this.composer.render()
    }
  }

  addEvents () {
    window.addEventListener('resize', this.resize.bind(this), false)
    this.resize()

    const canvas = document.querySelector('#' + this.config.scene.canvasID)

    const timeout = function () {
      this.userInteracting = true
      clearTimeout(this.interactionTimeout)
      this.interactionTimeout = setTimeout(() => {
        this.userInteracting = false
        const camPos = this.camera.getWorldPosition(new THREE.Vector3())
        this.cameraPos.x = camPos.x
        this.cameraPos.y = camPos.y
        this.cameraPos.z = camPos.z
        this.targetCameraPos.x = camPos.x
        this.targetCameraPos.y = camPos.y
        this.targetCameraPos.z = camPos.z
      }, 3000)
    }

    canvas.addEventListener('touchstart', (e) => {
      timeout.call(this)
    })

    canvas.addEventListener('mousedown', (e) => {
      timeout.call(this)
    })

    canvas.addEventListener('wheel', (e) => {
      timeout.call(this)
    })

    canvas.addEventListener('mousewheel', (e) => {
      timeout.call(this)
    })

    canvas.addEventListener('mousemove', this.onMouseMove.bind(this), false)
  }

  onMouseMove (e) {
    this.mousePos.x = e.clientX
    this.mousePos.y = e.clientY
  }

  initScene () {
    this.scene = new THREE.Scene()
    this.scene.background = new THREE.Color(this.config.scene.bgColor)
  }

  /**
   * Set up camera with defaults
   */
  initCamera () {
    this.camera = new THREE.PerspectiveCamera(this.config.camera.fov, window.innerWidth / window.innerHeight, 0.1, 2000000)
    this.camera.position.x = this.config.camera.initPos.x
    this.camera.position.y = this.config.camera.initPos.y
    this.camera.position.z = this.config.camera.initPos.z

    // speed of lerp
    this.cameraLerpSpeed = 0.03

    // set target positions
    this.cameraPos = this.camera.position.clone() // current camera position
    this.targetCameraPos = this.cameraPos.clone() // target camera position

    this.cameraLookAtPos = new THREE.Vector3(0, 0, 0) // current camera lookat
    this.targetCameraLookAt = new THREE.Vector3(0, 0, 0) // target camera lookat
    this.camera.lookAt(this.cameraLookAtPos)

    // set initial camera rotations
    this.cameraFromQuaternion = new THREE.Quaternion().copy(this.camera.quaternion)
    let cameraToRotation = new THREE.Euler().copy(this.camera.rotation)
    this.cameraToQuaternion = new THREE.Quaternion().setFromEuler(cameraToRotation)
    this.cameraMoveQuaternion = new THREE.Quaternion()

    this.camera.updateMatrixWorld()
    this.setCameraSettings()
  }

  setCameraSettings () {
    this.camera.fov = this.config.camera.fov
    this.camera.updateMatrixWorld()
  }

  /**
   * Move camera to target position
   */
  cameraFollowTarget () {
    this.camera.lookAt(this.cameraLookAtPos)
    if (!this.userInteracting) {
      // lerp camera position to target
      this.cameraPos.lerp(this.targetCameraPos, this.cameraLerpSpeed)
      this.camera.position.copy(this.cameraPos)

      // constantly look at target
      this.cameraLookAtPos.lerp(this.targetCameraLookAt, this.cameraLerpSpeed)
    }
  }

  /**
   * Set up default stage renderer
   */
  initRenderer () {
    this.renderer = new THREE.WebGLRenderer({
      antialias: this.config.scene.antialias,
      canvas: document.getElementById(this.config.scene.canvasID)
    })

    // this.renderer.setPixelRatio(window.devicePixelRatio)

    // this.composer = new EffectComposer(this.renderer)
  }

  /**
   * Window resize
   */
  resize () {
    if (this.config.scene.fullScreen) {
      this.width = window.innerWidth
      this.height = window.innerHeight
    } else {
      this.width = this.config.scene.width
      this.height = this.config.scene.height
    }

    this.config.scene.width = this.width
    this.config.scene.height = this.height

    this.camera.aspect = this.width / this.height
    this.camera.updateProjectionMatrix()
    this.renderer.setSize(this.width, this.height, false)

    this.composer.setSize(this.width, this.height)

    this.FDG.resize(this.width, this.height)
  }

  /**
   * Get commit data
   */
  async callAPI () {
    // only call this method if tab in focus
    let animID = this.callAPI
    if (this.currentFrame === this.prevAPICallFrame) {
      window.requestAnimationFrame(animID.bind(this))
      return
    } else {
      window.cancelAnimationFrame(animID)
    }

    this.prevAPICallFrame = this.currentFrame

    this.APIprocessing = true
    let commits

    if (this.config.fireBase.useChangesDB) {
      // only get changed data in play mode
      if (this.state.play) {
        this.docRef = this.firebaseDB.collection(this.repoChanges)
      } else {
        this.docRef = this.firebaseDB.collection(this.repo)
      }
    }

    this.commitsToProcess = []

    this.direction = ''

    // load commit by hash
    if (this.loadCommitHash !== '') {
      commits = this.docRef.doc(this.loadCommitHash)
    } else if (this.loadPrevCommit) { // load previous commit
      commits = this.docRef.where('index', '==', this.state.currentCommitIndex - 1).limit(1)
      this.direction = 'prev'
    } else if (this.loadNextCommit) { // load next commit
      commits = this.docRef.where('index', '==', this.state.currentCommitIndex + 1).limit(1)
      this.direction = 'next'
    } else if (this.config.git.loadLatest && !this.state.timestampToLoad) {
      commits = this.docRef.orderBy('index', 'desc').limit(1)
    } else if (this.state.timestampToLoad) {
      commits = this.docRef.where('date', '>=', this.state.timestampToLoad).limit(1)
    } else {
      commits = this.docRef.where('index', '==', this.state.currentCommitIndex + 1).limit(1)
      this.direction = 'next'
    }

    // reset flags
    this.loadCommitHash = ''
    this.loadPrevCommit = false
    this.loadNextCommit = false
    this.config.git.loadLatest = false

    // collect snapshots
    let snapshots = []

    let snapshotOptions = {}

    if (this.state.timestampToLoad) {
      snapshotOptions.includeMetadataChanges = true
    }

    commits.onSnapshot(snapshotOptions,
      async function (querySnapshot) {
        // if loading from a particular date, disable local storage cache
        if (this.state.timestampToLoad && querySnapshot.metadata.fromCache) {
          return
        }

        // no results found for this index, check for next/prev index in db
        if (querySnapshot.size === 0) {
          let commits = null
          if (this.direction === 'prev') {
            commits = this.docRef.where('index', '<', this.state.currentCommitIndex).orderBy('index', 'desc').limit(1)
          } else {
            commits = this.docRef.where('index', '>', this.state.currentCommitIndex).orderBy('index', 'asc').limit(1)
          }
          let snapshot = await commits.get()
          if (snapshot.size !== 0) {
            let commit = snapshot.docs[0].data()
            if (this.direction === 'prev') {
              this.setState({currentCommitIndex: commit.index + 1})
              this.loadPrevCommit = true
            } else {
              this.setState({currentCommitIndex: commit.index - 1})
              this.loadNextCommit = true
            }
            this.callAPI()
          }

          return
        }

        if (typeof querySnapshot.docs !== 'undefined') {
          querySnapshot.forEach(snapshot => {
            snapshots.push(snapshot)
            this.commitsToProcess.push(snapshot.id)
          })
        } else {
          snapshots.push(querySnapshot)
          this.commitsToProcess.push(querySnapshot.id)
        }

        // if no results found for the passed date, load latest commit
        if (this.state.timestampToLoad && snapshots.length === 0) {
          commits = this.docRef.orderBy('index', 'desc').limit(1)
          let snapshot = await commits.get()
          snapshots.push(snapshot)
          // if no newer results, check again in a minute
        } else if (snapshots.length === 0) {
          setTimeout(() => {
            if (this.state.play) {
              this.callAPI()
            }
          }, 60000)
          return
        }

        const addCommits = async () => {
          await this.asyncForEach(snapshots, async (snapshot) => {
            await this.updateGraph(snapshot)
          })
          this.APIprocessing = false
          this.callAPI()
        }
        addCommits()
      }.bind(this), function (error) {
        console.log(error)
      })
  }

  async updateGraph (doc) {
    return new Promise((resolve, reject) => {
      if (!doc.exists) {
        console.log('Error: Commit ' + doc.id + ' does not exist in repo')
        resolve()
      }
      let commit = doc.data()
      commit.sha = doc.id

      if (this.commitsToProcess.indexOf(doc.id) === -1) {
        resolve()
      }

      setTimeout(() => {
        this.edges = JSON.parse(commit.edges)

        if (doc.ref.parent.id === this.repo) {
          this.nodes = JSON.parse(commit.nodes)[0]
        } else {
          let nodeChanges = JSON.parse(commit.changes)
          nodeChanges.r.forEach((path) => {
            for (const key in this.nodes) {
              if (this.nodes.hasOwnProperty(key)) {
                const node = this.nodes[key]
                if (node.p === path) {
                  delete this.nodes[key]
                }
              }
            }
          })

          for (const id in this.nodes) {
            if (this.nodes.hasOwnProperty(id)) {
              if (nodeChanges.c.indexOf(this.nodes[id].p) !== -1) {
                this.nodes[id].u = 1.0
              } else {
                delete this.nodes[id].u
              }
            }
          }

          for (const newIndex in nodeChanges.i) {
            if (nodeChanges.i.hasOwnProperty(newIndex)) {
              const newNode = nodeChanges.i[newIndex]

              for (const key in this.nodes) {
                if (this.nodes.hasOwnProperty(key)) {
                  const oldNode = this.nodes[key]
                  if (oldNode.p === newNode.p) {
                    delete this.nodes[key]
                  }
                }
              }

              this.nodes[newIndex] = newNode
            }
          }

          for (const key in nodeChanges.a) {
            if (nodeChanges.a.hasOwnProperty(key)) {
              const node = nodeChanges.a[key]
              node.u = 1.0
              this.nodes[key] = node
            }
          }
        }

        this.cameraAccommodateNodes()

        if (this.FDG) {
          if (this.FDG.firstRun) {
            this.FDG.init({
              nodeData: this.nodes,
              edgeData: this.edges,
              nodeCount: this.config.FDG.nodeCount
            })
            this.FDG.setFirstRun(false)
          } else {
            this.FDG.refresh()
            this.FDG.init({
              nodeData: this.nodes,
              edgeData: this.edges,
              nodeCount: this.config.FDG.nodeCount
            })
          }
        }

        if (this.state.play) {
          resolve()
        } else {
          this.APIprocessing = false
        }
      }, this.config.FDG.delayAmount)
    })
  }

  async asyncForEach (array, callback) {
    for (let index = 0; index < array.length; index++) {
      await callback(array[index], index, array)
    }
  }

  /**
   * Roughly keep all nodes visible to camera
   */
  cameraAccommodateNodes () {
    // get vector to center
    let toCentre = this.camera.getWorldPosition(new THREE.Vector3()).normalize()

    const nodeCount = Object.keys(this.nodes).length

    // y = ax^2 + bx + c
    let dist = (0.0001 * (Math.pow(nodeCount, 2))) + (1 * (nodeCount)) + this.config.camera.initPos.z
    if (this.state.spherize) {
      if (this.config.scene.width > this.config.scene.height) {
        dist = this.config.FDG.sphereRadius + 1200.0
      } else {
        dist = this.config.FDG.sphereRadius + 1600.0
      }
    }
    let newPos = toCentre.multiplyScalar(dist)
    this.targetCameraPos.x = newPos.x
    this.targetCameraPos.y = newPos.y
    this.targetCameraPos.z = newPos.z
  }

  toggleSpherize () {
    this.config.FDG.sphereProject = !this.state.spherize
    this.setState({spherize: this.config.FDG.sphereProject})
  }

  setPlay (bool) {
    let play = bool
    this.setState({play: play})

    if (!play) {
      this.APIprocessing = false
      this.commitsToProcess = []
    }

    if (play && !this.APIprocessing) {
      this.callAPI()
    }
  }

  togglePlay () {
    let play = !this.state.play
    this.setState({play: play})

    if (!play) {
      this.APIprocessing = false
      this.commitsToProcess = []
    }

    if (play && !this.APIprocessing) {
      this.callAPI()
    }
  }

  loadCommit (hash = '') {
    if (hash) {
      this.loadCommitHash = hash
      this.commitsToProcess = [hash]
      this.setState({play: false})
      this.callAPI()
    }
  }

  goToPrev () {
    this.loadPrevCommit = true
    this.commitsToProcess = []
    this.setState({play: false})
    this.callAPI()
  }

  goToNext () {
    this.loadNextCommit = true
    this.commitsToProcess = []
    this.setState({play: false})
    this.callAPI()
  }

  setConfig (newConfig) {
    this.config = deepAssign(this.config, newConfig)

    this.setControlsSettings()
    this.setPostSettings()
    this.setCameraSettings()

    if (this.FDG && this.FDG.active === true) {
      this.FDG.triggerUpdate()
    }
  }

  destroy () {
    this.renderer.dispose()

    this.scene.traverse(function (object) {
      if (object.geometry) {
        object.geometry.dispose()
      }
      if (object.material) {
        object.material.dispose()
      }
    })

    this.controls.dispose()

    delete this.composer
    delete this.renderer
    delete this.scene
    delete this.controls
    delete this.FDG

    window.cancelAnimationFrame(this.animate)
    this.running = false
  }

  render () {
    return (
      <div className='App'>
        <a href='https://scottdarby.com' target='_blank' rel='noopener noreferrer'><img className='logo' width='70' src={Logo} alt='Scott Darby' /></a>
        <canvas width={this.config.scene.width} height={this.config.scene.height} id={this.config.scene.canvasID} />
      </div>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/App.js